export default "__VITE_ASSET__cef9d333__"